export const surveyStatus = [
  { value: 1, text: "Bản nháp", color: "lightgray" },
  { value: 2, text: "Chờ duyệt", color: "lightgray" },
  { value: 3, text: "Đã duyệt", color: "green" },
  { value: 4, text: "Từ chối", color: "red" },
  { value: 5, text: "Đã xuất bản", color: "orange" },
  { value: 6, text: "Đã kết thúc", color: "blue" },
  { value: 7, text: "Thu hồi xuất bản", color: "orange" },
];
